import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { obterStatusRequerimentosRequest } from '@store/requerimento/actions';
import { LoadingIndicator } from '@components';
import { DeferidoItem } from './components/DeferidoItem';

export const Deferidos = () => {
  const dispatch = useDispatch();
  const deferidos = useSelector((state) => state.requerimento.deferido);
  const isLoading = useSelector((state) => state.loading.show);

  useEffect(() => {
    dispatch(obterStatusRequerimentosRequest({ status: 'deferido' }));
  }, [dispatch]);

  return isLoading ? (
    <LoadingIndicator />
  ) : (
    <div>
      {deferidos.map((requerimento) => {
        return (
          <DeferidoItem
            key={requerimento.Protocolo}
            requerimento={requerimento}
          />
        );
      })}
      {deferidos.length === 0 && (
        <div className="card">
          <div className="card-body">
            <p>Você não possui requerimentos deferidos</p>
          </div>
        </div>
      )}
    </div>
  );
};
